import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { fetchInvoice } from '../../../../actions/invoice/invoiceDetail'
import { InvoiceDetails } from '..'
import { AppState } from '../../../../reducers'
import { InvoiceDetailState } from '../../../../reducers/invoice/invoiceDetail'
import { useTranslation } from 'react-i18next'
import { Paper, Box, Typography, Button, Stack } from '@mui/material';
import { KeyboardReturnOutlined } from '@mui/icons-material';
import moment from 'moment';
import { formattedCurrency } from '../../../../utils/StringUtils'
import { useThemeContext } from '../../../../theme/ThemeContext'

interface Props {
  invoiceDetail: InvoiceDetailState
}

const InvoiceDetail: React.FC<Props> = ({ invoiceDetail }) => {
  const dispatch = useDispatch()
  const params = useParams<{ invoiceId: string, clientId?: string }>()
  const history = useHistory()
  const { t } = useTranslation(['invoice', 'others'])
  const { theme } = useThemeContext()

  useEffect(() => {
    dispatch(fetchInvoice(params.invoiceId, params.clientId, history.location.search))
  }, [dispatch, params.invoiceId, params.clientId, history.location.search])

  const HeaderDetail: React.FC = () => {

    return (
      <Paper elevation={2} sx={{ margin: "10px", padding: "2px 2px 2px 2px", bgcolor: theme.palette.success.main }}>
        <Paper elevation={2}
          style={{
            padding: "15px 15px 15px 15px", display: "flex", flexDirection: "column",
            textAlign: "justify", justifyContent: "space-around",
            borderRadius: "4px", margin: "4px"
          }}>
          {invoiceDetail.invoiceLines && invoiceDetail.invoiceLines.length > 0 &&
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('invoice')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{invoiceDetail.invoiceLines[0].id_factura}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('date')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{moment(invoiceDetail.invoiceLines[0].fecha).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('dueDate')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{moment(invoiceDetail.invoiceLines[0].fecha_vencimiento).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('totalNoTax')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{formattedCurrency(invoiceDetail.invoiceLines.reduce((neto, invoice) => neto + Number(invoice.importe), 0))}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('total')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{formattedCurrency(invoiceDetail.invoiceLines[0].importe_total_comprobante)}</Typography>
              </Box>
            </Box>}
        </Paper>
      </Paper>
    )
  }


  return (
    <Stack style={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100% - var(--header-height)' }}>
      <HeaderDetail />
      <InvoiceDetails
        rows={(invoiceDetail.invoiceLines || []).map(s => ({ data: s }))}
        loading={invoiceDetail.isFetching}
        pagination={invoiceDetail.pagination || undefined}
      />
      <Box display="flex" justifyContent="flex-start" alignItems="center">
        <Button color="secondary" variant="contained" sx={{ textTransform: "none", margin: "10px" }} startIcon={<KeyboardReturnOutlined />} onClick={() => history.goBack()}>{t("back", { ns: 'others' })}</Button>
      </Box>
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  invoiceDetail: state.invoiceDetail
})


export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(InvoiceDetail);